const services = [
  {
    label: "01 · Documents",
    title: "The chase, automated",
    text: "Requests go out on your cadence, reminders follow on a schedule, and anything overdue escalates to a named owner. One screen shows every client and what is still missing, so nobody rebuilds the list by hand.",
  },
  {
    label: "02 · Close prep",
    title: "Checklists that hold",
    text: "Every task carries an owner and a dependency. A missing statement shows up as a blocked P&L on day two instead of a late invoice on day twelve, and the close stops depending on who remembers what.",
  },
  {
    label: "03 · Reconciliation",
    title: "Books that balance on schedule",
    text: "Bank, ledger and subledger matched on a routine, with the exceptions listed rather than buried in the matching. Every figure traces back to the document it came from.",
  },
  {
    label: "04 · Reporting",
    title: "Packs that build themselves",
    text: "The reporting pack assembles from reconciled data, with flux commentary drafted for review. Your team checks the numbers instead of collecting them from six spreadsheets.",
  },
];

export default function Services() {
  return (
    <section id="services" className="t-sec t-sec--alt" aria-labelledby="services-title">
      <div className="t-wrap">
        <div className="t-block-head">
          <h2 id="services-title" className="t-h2 t-rise">
            Where the hours actually go.
          </h2>
          <p className="t-body t-para t-rise">
            Four jobs, one chain. Fixing one shows you where the next one leaks.
          </p>
        </div>

        <div className="t-grid-2 t-gap-top">
          {services.map((service) => (
            <article key={service.title} className="t-cell t-rise">
              <p className="t-cell__label">{service.label}</p>
              <h3 className="t-h3 t-cell__title">{service.title}</h3>
              <p className="t-cell__text">{service.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
